import { render, staticRenderFns } from "./KPdetails.vue?vue&type=template&id=0524c474&scoped=true&"
import script from "./KPdetails.vue?vue&type=script&lang=js&"
export * from "./KPdetails.vue?vue&type=script&lang=js&"
import style0 from "./KPdetails.vue?vue&type=style&index=0&id=0524c474&lang=scss&scoped=true&"
import style1 from "./KPdetails.vue?vue&type=style&index=1&id=0524c474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524c474",
  null
  
)

export default component.exports